<template>
	<div>
		<v-app id="app" class="mb-sm-5">
			<vue-progress-bar></vue-progress-bar>
			<snackbar />
			<component
				:is="$route.meta.layout"
				:class="{
					appDark: $vuetify.theme.isDark,
					appLight: !$vuetify.theme.isDark,
				}"
			>
				<router-view />
			</component>
		</v-app>
	</div>
</template>

<script>
import * as PusherPushNotifications from '@pusher/push-notifications-web';
import Snackbar from '@/components/ui/Snackbar';

export default {
	name: 'App',
	components: {
		Snackbar,
	},
	mounted() {
		// if (this.userProfile && this.userProfile._id) this.verifyBeams();
	},
	methods: {
		verifyBeams() {
			try {
				const beamsClient = new PusherPushNotifications.Client({
					instanceId: process.env.VUE_APP_PUSHER_BEAMS_INSTANCE,
				});
				beamsClient
					.getUserId()
					.then(userId => {
						// Check if the Beams user matches the user that is currently logged in
						if (userId !== this.userProfile._id) {
							// Unregister for notifications
							return beamsClient.stop();
						}
					})
					.catch(console.error);
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>

<style lang="scss">
.maxInput {
	max-width: 300px !important;
}
.backgroundTransparent {
	background-color: transparent !important;
}

@font-face {
	font-display: swap;
	src: local('Roboto'), url(./assets/fonts/Roboto-Regular.ttf) format('truetype');
	font-family: 'Roboto';
}

html {
	overflow-y: auto;
	overflow-x: hidden;
}

.spacerBottom {
	width: 100%;
	height: 100px;
}
.v-application {
	font-family: 'Montserrat', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.bgLight {
	background-color: white;
	border-bottom: none;
	box-shadow: none;
}
.bgDark {
	background: linear-gradient(90deg, black, #6a31ff17 50%, #0000008c 100%);
	background-image: -webkit-linear-gradient(60deg, #040211cc, rgba(10, 0, 62, 0.02), #040211cc);
	box-shadow: 0px 1px 6px -2px black;
}

.fade-enter-active {
	transition: opacity 0.3s;
}
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* width */
::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
	background: transparent;
}
/* Handle */
::-webkit-scrollbar-thumb {
	background: #8181811c;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #8181816e;
}
.pointer {
	cursor: pointer;
}

.page-enter-active,
.page-leave-active {
	transition: opacity 0.5s;
}
.page-enter,
.page-leave-to {
	opacity: 0;
}
</style>

<style media="screen">
.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled
	> .v-input__control
	> .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--single-line
	> .v-input__control
	> .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined
	> .v-input__control
	> .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled
	> .v-input__control
	> .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--single-line
	> .v-input__control
	> .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled
	> .v-input__control
	> .v-input__slot {
	min-height: 29px !important;
}

.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__prepend-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
	.v-input__append-outer {
	margin-top: 2px;
}

.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label,
.v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
	top: 5px !important;
}
.sub-main-class {
	padding-top: 10px;
	padding-left: 10px;

	margin-top: 10px;
	margin-left: 10px;

	padding-bottom: 10px;
	padding-right: 10px;

	margin-bottom: 10px;
	margin-right: 10px;

	border-radius: 25px;
	background-color: #ffffffd1;
}
.appLight {
	/* background-size: cover;
	background-image: url('./assets/background-image-fly4.jpeg') !important; */
	text-align: center;
	overflow: hidden;
	height: 100%;
	line-height: 1.2;
}

.appDark {
	background-image: url('./assets/background-image-fly13.jpeg') !important;
	background-size: cover;

	text-align: center;
	overflow: hidden;
	height: 100%;
	line-height: 1.2;
}

.routerViewLight {
	background-color: #ffffffad;
	padding-bottom: 20px;
}
.routerViewDark {
	background-color: #000000ad;
	padding-bottom: 20px;
}
</style>
